var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
/** Uma profissao na lista do formulario. */
let ProfessionalTypeScope = class ProfessionalTypeScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.value = '';
        this.current = false;
        this.onSelect = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], ProfessionalTypeScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ProfessionalTypeScope.prototype, "value", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ProfessionalTypeScope.prototype, "current", void 0);
ProfessionalTypeScope = __decorate([
    Observable
], ProfessionalTypeScope);
export { ProfessionalTypeScope };
/** Alguem que ja esta na plataforma, na lista de quem da para vincular. */
let CompanyCandidateScope = class CompanyCandidateScope extends Scope {
    constructor() {
        super(...arguments);
        this.name = '';
        this.email = '';
        this.cpfMascarado = '';
        /** De outra empresa sua: a lista diz de onde a pessoa saiu. */
        this.minha = false;
        this.onSelect = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyCandidateScope.prototype, "name", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyCandidateScope.prototype, "email", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyCandidateScope.prototype, "cpfMascarado", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyCandidateScope.prototype, "profissao", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyCandidateScope.prototype, "minha", void 0);
CompanyCandidateScope = __decorate([
    Observable
], CompanyCandidateScope);
export { CompanyCandidateScope };
/**
 * O formulario de um usuario da empresa.
 *
 * Sem campo de senha, de proposito: ela e gerada e vai por e-mail, como no
 * administrador que nasce junto com a empresa. Quem cadastra nao escolhe a senha de
 * outra pessoa - e por isso tambem nao ha confirmacao de senha aqui.
 */
let CompanyUserFormScope = class CompanyUserFormScope extends Scope {
    constructor() {
        super(...arguments);
        this.title = '';
        /** Se e o cadastro de profissional - o que faz aparecer o bloco do conselho. */
        this.professional = false;
        /**
         * O que esta tela esta fazendo: criando uma pessoa, ou VINCULANDO uma que existe.
         *
         * Duas coisas diferentes com o mesmo fim, e por isso um modo em vez de duas
         * telas. O `cadastro` reconhece uma conta pelo e-mail digitado e se converte em
         * vinculo sozinho; o `vinculo` comeca pela lista de quem ja esta, que e o
         * caminho de quem sabe que a pessoa existe e nao quer digitar nada.
         */
        this.mode = 'cadastro';
        /** O que foi digitado na busca de quem ja esta na plataforma. */
        this.candidateTerm = '';
        this.candidates = [];
        this.candidatesLoading = false;
        /** Se a busca ja respondeu - para nao dizer "ninguem" antes de procurar. */
        this.candidatesAsked = false;
        this.onModeChanged = Scope.SYNC_ACTION_STRING;
        this.onCandidateTermChanged = Scope.SYNC_ACTION_STRING;
        /** Volta para a lista depois de ter escolhido alguem. */
        this.onForgetCandidate = Scope.ASYNC_ACTION;
        this.saving = false;
        /** Enquanto o e-mail esta sendo procurado. */
        this.looking = false;
        /**
         * Quando a tela vira VINCULO, e nao cadastro.
         *
         * Os campos de pessoa saem: quem ja tem conta ja tem nome e telefone, e pedi-los
         * de novo faria a tela parecer que vai criar outra pessoa - e o que fosse digitado
         * seria descartado. Fica so o CPF, que e a prova de identidade.
         */
        this.linking = false;
        this.firstName = '';
        this.lastName = '';
        this.email = '';
        this.cpf = '';
        this.phone = '';
        // :: so no profissional
        /** A profissao escolhida, pelo nome, para o gatilho da lista mostrar. */
        this.typeSummary = '';
        this.types = [];
        /**
         * As ESPECIALIDADES da profissao escolhida, e a escolhida entre elas.
         *
         * Vazio quando a profissao nao tem especialidade - personal trainer e fisiologista
         * nao tem - e o segundo seletor nem aparece. O catalogo virou dois niveis em
         * 18/09/2026: as 55 linhas que existiam sao as especialidades de "Medico".
         */
        this.specialtySummary = '';
        this.specialties = [];
        this.registrationNumber = '';
        this.uf = '';
        /**
         * Se o conselho escolhido e regulamentado.
         *
         * O conselho mora na PROFISSAO, e a especialidade herda. Sem conselho nao ha
         * registro para pedir, e um campo obrigatorio ali seria um campo que a pessoa nao
         * tem como preencher. Ate 18/09/2026 esse caminho nunca tinha sido acionado - as 55
         * linhas do catalogo eram todas do CRM.
         */
        this.regulated = false;
        this.onFirstNameChanged = Scope.SYNC_ACTION_STRING;
        this.onLastNameChanged = Scope.SYNC_ACTION_STRING;
        this.onEmailChanged = Scope.SYNC_ACTION_STRING;
        this.onCpfChanged = Scope.SYNC_ACTION_STRING;
        this.onPhoneChanged = Scope.SYNC_ACTION_STRING;
        /** Desfaz a escolha da profissao - o X ao lado do seletor. Leva a especialidade junto. */
        this.onClearType = Scope.ASYNC_ACTION;
        /** Desfaz so a especialidade, mantendo a profissao. */
        this.onClearSpecialty = Scope.ASYNC_ACTION;
        this.onRegistrationChanged = Scope.SYNC_ACTION_STRING;
        this.onUfChanged = Scope.SYNC_ACTION_STRING;
        this.onSave = Scope.ASYNC_ACTION;
        this.onClose = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserFormScope.prototype, "title", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserFormScope.prototype, "professional", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyUserFormScope.prototype, "mode", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserFormScope.prototype, "candidateTerm", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], CompanyUserFormScope.prototype, "candidates", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserFormScope.prototype, "candidatesLoading", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserFormScope.prototype, "candidatesAsked", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserFormScope.prototype, "saving", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyUserFormScope.prototype, "existingName", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyUserFormScope.prototype, "existingCpf", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyUserFormScope.prototype, "existingBlock", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserFormScope.prototype, "looking", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserFormScope.prototype, "linking", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyUserFormScope.prototype, "formError", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserFormScope.prototype, "firstName", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserFormScope.prototype, "lastName", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserFormScope.prototype, "email", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserFormScope.prototype, "cpf", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserFormScope.prototype, "phone", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyUserFormScope.prototype, "firstNameError", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyUserFormScope.prototype, "lastNameError", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyUserFormScope.prototype, "emailError", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyUserFormScope.prototype, "cpfError", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyUserFormScope.prototype, "phoneError", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserFormScope.prototype, "typeSummary", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], CompanyUserFormScope.prototype, "types", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserFormScope.prototype, "specialtySummary", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], CompanyUserFormScope.prototype, "specialties", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserFormScope.prototype, "registrationNumber", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserFormScope.prototype, "uf", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserFormScope.prototype, "regulated", void 0);
CompanyUserFormScope = __decorate([
    Observable
], CompanyUserFormScope);
export { CompanyUserFormScope };
//# sourceMappingURL=company-user-form.scope.js.map